<script>
import { Row, Col, Cell, Image, Icon, Tag, Grid, GridItem, List, Toast, Empty, Dialog } from 'vant'
import { QNImageUtil } from '@/utils'
import { setTitle } from '@/libs/ds-bridge'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-organization-manage',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
        'van-cell': Cell,
        'van-image': Image,
        'van-icon': Icon,
        'van-tag': Tag,
        'van-grid': Grid,
        'van-grid-item': GridItem,
        'van-list': List,
        'van-empty': Empty
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            organizationManager: {
                organization: {
                    id: null,
                    name: null,
                    logoUrl: null,
                    duration: null,
                    area: null,
                    areaId: null,
                    authStatus: null,
                },
                matchList: null,
                role: {
                    isManager: null,
                    isMatchManager: null,
                    isReferee: null,
                },
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        organizationCheckInPeriod() {
            let label = ''
            if (this.organizationManager.organization.duration) {
                label = this.locale.localeProp('check-in-period', this.organizationManager.organization.duration)
            }
            return label
        },
        isMatchListEmtpy() {
            return this.organizationManager.matchList 
                && (this.organizationManager.matchList.length == 0)
        },
        showAccount() {
            return this.isManager()
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    mounted() {
        setTitle("")
    },
    methods: {
        onExchangeBtnClick() {
            console.log('onExchangeBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgListOrganization',
                    query: {
                        from: 'OrgManageOrganization'
                    }
                }
            })
        },
        onAuthStatusIconClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgDetailOrganization',
                    params: {
                        id: this.organizationManager.organization.id
                    },
                    query: {
                        tab: 1
                    }
                }
            })
        },
        onGoAccountBtnClick() {
            if (this.organizationManager.organization.authStatus == '1' 
                || this.organizationManager.organization.authStatus == '4') {
                Dialog.confirm({
                    title: this.locale['go-account'],
                    message: this.locale['go-auth-confirm-message'],
                    confirmButtonText: this.locale['go-auth'],
                }).then(() => {
                    // on confirm
                    // navigate to the organization detail page with auth tab
                    this.$emit('custom-event', {
                        type: 'navigate',
                        data: {
                            name: 'OrgDetailOrganization',
                            params: {
                                id: this.organizationManager.organization.id
                            },
                            query: {
                                tab: 1
                            }
                        }
                    })
                }).catch(() => {
                    // on cancel
                })
            }
        },
        onTodoItemClick() {
            Toast(this.locale['coming-soon'])
        },
        onServiceBtnClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    url: 'https://www.snsports.cn/webapplt/index/index.html#/customer-service/bd-agent'
                }
            })
        },
        onRefereeAdminItemClick() {
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgListReferee',
                    query: {
                        organizationId: this.organizationManager.organization.id
                    }
                }
            })
        },
        onStaffAdminItemClick() {
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgListStaff',
                    query: {
                        organizationId: this.organizationManager.organization.id
                    }
                }
            })
        },
        onOrgnizationInfoItemClick() {
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgDetailOrganization',
                    params: {
                        id: this.organizationManager.organization.id
                    }
                }
            })
        },
        onCreateMatchBtnClick() {
            console.log('onCreateMatchBtnClick')
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateMatchName',
                    query: {
                        hideOrg: 'true',
                        organizationId: this.organizationManager.organization.id,
                        organizationName: this.organizationManager.organization.name,
                        organizationLogoUrl: this.organizationManager.organization.logoUrl,
                        organizationArea: this.organizationManager.organization.area,
                        organizationAreaId: this.organizationManager.organization.areaId
                    }
                }
            })
        },
        onMatchItemClick(item) {
            if(item.isBangSaiShi > 0) {
                this.$emit('custom-event', {
                    type: 'navigate',
                    data: {
                        name: 'OrgManageMatch',
                        params: {
                            id: item.id
                        },
                        /*query: {
                            organizationId: this.organizationManager.organization.id
                        }*/
                    }
                })
            } else {
                if(item.id.startsWith('match')) {
                    const matchId = item.id.replace(/match_/g, '');
                    window.location.href = 'banmabang://matchmanage?matchId=' + matchId;
                } else {
                    window.location.href = 'banmabang://union?id=' + item.id;
                }
            }
        },
        matchStatusField(item) {
            return this.locale.localeProp('match-status-option-' 
                + (item.status ? item.status : '1'))
        },
        matchCheckInPeriod(item) {
            console.log('matchCheckInPeriod', item.duration.num, item.duration.unit)
            let label = ''
            if (item.duration) {
                label = this.locale.localeProp('check-in-period', item.duration)
            }
            return label
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        isManager() {
            return this.organizationManager.role.isManager || this.organizationManager.role.isMatchManager
        },
        validateManager() {
            console.log('validateManager', this.isManager())
            if (this.isManager()) {
                return true
            }
            else {
                Toast(this.locale['no-permission'])
                return false
            }
        }
    },
}
</script>

<template>
    <div class="organization-manage">
        <div class="background"/>
        <div class="nav-op-bar fixed-top">
            <van-row class="hp100 vertical-center text-center">
                <van-col span="8">
                    <van-icon
                        class-prefix="iconfont"
                        name="service"
                        size="21"
                        @click="onServiceBtnClick"
                    />
                </van-col>
                <van-col span="8">
                    <van-icon
                        name="envelop-o"
                        size="21"
                        badge="99+"
                        @click="onTodoItemClick"
                    />
                </van-col>
                <van-col span="8">
                    <van-icon
                        name="add-o"
                        size="21"
                        @click="onCreateMatchBtnClick"
                    />
                </van-col>
            </van-row>
        </div>
        <div class="head b-outer-margin">
            <van-cell class="u-inner-padding">
                <template #title>
                    <van-row type="flex">
                        <van-col class="vertical-center">
                            <van-image 
                                v-if="organizationManager.organization.logoUrl"
                                :src="adjustImageSize(organizationManager.organization.logoUrl, 68, 68)" 
                                round center
                                fit="cover" 
                                width="34px" 
                                height="34px"
                            />
                        </van-col>
                        <van-col class="name-field vertical-center">
                            <template #default>
                                <div class="wrapper u-outer-padding">
                                    <div>
                                        <span class="label block van-ellipsis">{{ organizationManager.organization.name }}</span>
                                    </div>
                                    <div class="second-line vertical-center">
                                        <van-tag class="r-outer-margin">{{ organizationCheckInPeriod }}</van-tag>
                                        <div class="vertical-center" @click="onAuthStatusIconClick">
                                            <img v-if="organizationManager.organization.authStatus == '1'" src="@/assets/org/auth-status-init-icon.svg"/>
                                            <img v-else-if="organizationManager.organization.authStatus == '2'" src="@/assets/org/auth-status-checking-icon.svg"/>
                                            <img v-else-if="organizationManager.organization.authStatus == '3'" src="@/assets/org/auth-status-passed-icon.svg"/>
                                            <img v-else-if="organizationManager.organization.authStatus == '4'" src="@/assets/org/auth-status-failed-icon.svg"/>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </van-col>    
                        <van-col class="vertical-center">
                            <van-icon 
                                class="exchange-icon" 
                                name="exchange"
                                @click="onExchangeBtnClick"
                            />
                        </van-col>
                    </van-row>
                </template>
            </van-cell>
        </div>
        <div v-if="showAccount" class="b-outer-margin">
            <van-cell 
                class="u-inner-padding"
                :title="locale['account']"
                is-link center
                @click="onGoAccountBtnClick"
            >
                <template #icon>
                    <img class="r-inner-margin" src="@/assets/org/account-symbol.svg"/>
                </template>
                <template #default>
                    <div class="h-outer-padding">
                        <div class="lh1">
                            <span class="minor-text main-secondary-color">{{ locale['go-account'] }}</span>
                        </div>
                        <div class="lh1">
                            <span class="support-text minor-color">{{ locale['go-account-description'] }}</span>
                        </div>
                    </div>
                </template>
            </van-cell>
        </div>
        <div class="functional-grid grid-item-less-padding b-outer-margin">
            <van-grid :border="false">
                <van-grid-item :text="locale['team-list']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/team-list-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['video-library']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/video-library-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['schedule-table']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/schedule-table-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['referee-admin']" @click="onRefereeAdminItemClick">
                    <template #icon>
                        <img src="@/assets/org/referee-admin-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['staff-admin']" @click="onStaffAdminItemClick">
                    <template #icon>
                        <img src="@/assets/org/staff-admin-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['asset-library']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/asset-library-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['mini-program']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/mini-program-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['organization-info']" @click="onOrgnizationInfoItemClick">
                    <template #icon>
                        <img src="@/assets/org/organization-info-icon.svg"/>
                    </template>
                </van-grid-item>
            </van-grid>
        </div>
        <div class="added-service-grid grid-item-no-padding b-outer-margin">
            <van-grid :gutter="0" direction="horizontal" :column-num="2">
                <van-grid-item @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/added-service-unit-01.png" style="width: 171px; height: 66px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/added-service-unit-02.png" style="width: 171px; height: 66px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/added-service-unit-03.png" style="width: 171px; height: 66px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/added-service-unit-04.png" style="width: 171px; height: 66px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/added-service-unit-05.png" style="width: 171px; height: 66px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/added-service-unit-06.png" style="width: 171px; height: 66px;"/>
                    </template>
                </van-grid-item>
            </van-grid>
        </div>
        <div class="match-list bg-white u-outer-padding">
            <div class="list-title b-outer-padding relative">
                <span class="text-title">{{ locale['match-list'] }}</span>
                <div class="full-separator-line-bottom"/>
            </div>
            <div v-if="!isMatchListEmtpy">
                <van-list>
                    <div
                        class="h-inner-padding van-hairline--bottom"
                        v-for="item in organizationManager.matchList"
                        :key="item.id"
                        @click="onMatchItemClick(item)"
                        >
                        <div class="match-name-unit b-inner-margin">
                            <span class="main-text">{{ item.name }}</span>
                            <span class="minor-text pull-right">
                                <van-tag>{{ matchStatusField(item) }}</van-tag>
                            </span>
                        </div>
                        <van-row class="match-info b-inner-margin">
                            <van-col class="r-outer-margin h50">
                                <van-image 
                                    v-if="item.logoUrl"
                                    :src="adjustImageSize(item.logoUrl, 100, 100)" 
                                    fit="cover" 
                                    width="50px" 
                                    height="50px"
                                />
                                <img
                                    v-else
                                    src="@/assets/org/logo-symbol.png"
                                    style="width: 50px; height: 50px;"
                                />
                            </van-col>
                            <van-col>
                                <div>
                                    <span class="minor-text minor-color r-outer-margin">{{ locale['sport-type-1'] }}</span>
                                    <span class="minor-text minor-color">{{ item.periodDate }}</span>
                                </div>
                            </van-col>
                        </van-row>
                        <div class="tag-bar b-inner-padding">
                            <van-tag>{{ matchCheckInPeriod(item) }}</van-tag>
                        </div>
                    </div>
                </van-list>
            </div>
            <div v-else @click="onCreateMatchBtnClick">
                <van-empty 
                    :description="locale['match-empty-hint']"
                    image-size="0"
                >
                    <van-button round plain type="info" class="btn">{{ locale['create-now'] }}</van-button>
                </van-empty>
            </div>
        </div>
        <div class="branding-section text-center">
            <img src="@/assets/org/logo-bottom-grey.png"/>
        </div>
    </div>
</template>

<style scoped>
.background {
    position: absolute;
    top: 0;
    width: 100%;
    height: 426px;
    background: linear-gradient(180deg, #E1EDF9 0%, rgba(225, 237, 249, 0) 100%);
}
.exchange-icon {
    position: absolute;
    top: 24px;
    right: 16px;
}
.name-field .van-cell__value span {
    font-size: 16px;
}
.name-field .wrapper {
    padding-left: 6px;
}
.name-field .label {
    max-width: 280px;
}
.name-field .second-line {
    line-height: 1;
}
.branding-section {
    margin-top: 10px;
}
.branding-section img {
    width: 301px;
    height: 60px;
}
</style>
<style>
.organization-manage .van-empty__bottom {
    margin-top: 0;
}
</style>